import { Link } from "react-router-dom";
import "../../../style/icon/bootstrap/bootstrap-icons.min.css"
const BootstrapIcons = () => {
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper cardhead">
        <div className="content">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Bootstrap Icon</h3>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            {/* Chart */}
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <div className="card-title">Bootstrap Icons</div>
                </div>
                <div className="card-body">
                  <p className="mb-2">
                    <code>&lt;i class="bi bi-ICON_NAME"&gt;&lt;/i&gt;</code>. For
                    more information{" "}
                    <Link
                      to="https://icons.getbootstrap.com/"
                      target="_blank"
                      className="text-primary"
                    >
                      click here
                    </Link>
                    .
                  </p>
                  <div className="icons-items">
                    <div className="icons-list">
                      <div className="icons-list-item">
                        <i
                          className="bi bi-house"
                          data-bs-toggle="tooltip"
                          title="bi bi-house"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-speedometer2"
                          data-bs-toggle="tooltip"
                          title="bi bi-speedometer2"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-map"
                          data-bs-toggle="tooltip"
                          title="bi bi-map"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-chat-left-text"
                          data-bs-toggle="tooltip"
                          title="bi bi-chat-left-text"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-people"
                          data-bs-toggle="tooltip"
                          title="bi bi-people"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-card-image"
                          data-bs-toggle="tooltip"
                          title="bi bi-card-image"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-file-earmark-text"
                          data-bs-toggle="tooltip"
                          title="bi bi-file-earmark-text"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-bar-chart"
                          data-bs-toggle="tooltip"
                          title="bi bi-bar-chart"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-arrow-clockwise"
                          data-bs-toggle="tooltip"
                          title="bi bi-arrow-clockwise"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-list"
                          data-bs-toggle="tooltip"
                          title="bi bi-list"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-gear"
                          data-bs-toggle="tooltip"
                          title="bi bi-gear"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-building"
                          data-bs-toggle="tooltip"
                          title="bi bi-building"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-basket"
                          data-bs-toggle="tooltip"
                          title="bi bi-basket"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-camera-reels"
                          data-bs-toggle="tooltip"
                          title="bi bi-camera-reels"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-bell"
                          data-bs-toggle="tooltip"
                          title="bi bi-bell"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-envelope"
                          data-bs-toggle="tooltip"
                          title="bi bi-envelope"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-pin-angle"
                          data-bs-toggle="tooltip"
                          title="bi bi-pin-angle"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-pie-chart"
                          data-bs-toggle="tooltip"
                          title="bi bi-pie-chart"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-check2-square"
                          data-bs-toggle="tooltip"
                          title="bi bi-check2-square"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-check2-all"
                          data-bs-toggle="tooltip"
                          title="bi bi-check2-all"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-archive"
                          data-bs-toggle="tooltip"
                          title="bi bi-archive"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-arrow-down-square"
                          data-bs-toggle="tooltip"
                          title="bi bi-arrow-down-square"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-arrow-down-up"
                          data-bs-toggle="tooltip"
                          title="bi bi-arrow-down-up"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-cloud-arrow-down"
                          data-bs-toggle="tooltip"
                          title="bi bi-cloud-arrow-down"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-database"
                          data-bs-toggle="tooltip"
                          title="bi bi-database"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-laptop"
                          data-bs-toggle="tooltip"
                          title="bi bi-laptop"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-exclamation-circle"
                          data-bs-toggle="tooltip"
                          title="bi bi-exclamation-circle"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-three-dots-vertical"
                          data-bs-toggle="tooltip"
                          title="bi bi-three-dots-vertical"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-download"
                          data-bs-toggle="tooltip"
                          title="bi bi-download"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-trash3"
                          data-bs-toggle="tooltip"
                          title="bi bi-trash3"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-folder2-open"
                          data-bs-toggle="tooltip"
                          title="bi bi-folder2-open"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-calendar"
                          data-bs-toggle="tooltip"
                          title="bi bi-calendar"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-star"
                          data-bs-toggle="tooltip"
                          title="bi bi-star"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-clock"
                          data-bs-toggle="tooltip"
                          title="bi bi-clock"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-telephone"
                          data-bs-toggle="tooltip"
                          title="bi bi-telephone"
                        />
                      </div>
                      <div className="icons-list-item">
                        <i
                          className="bi bi-camera-video"
                          data-bs-toggle="tooltip"
                          title="bi bi-camera-video"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Chart */}
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>

  );
};
export default BootstrapIcons;
